<template>
  <!----------------------------------------- LABOUR COMPONENT  ------------------------------->
  <div>
    <!--------------------Mechanical ----------------------->    <div class="mb-5"
      v-if="selectedTab.type == ItemCategoryTypes.MECH || selectedViewType != viewTypes.tabbedView">
      <quote-builder-other-labour-headings-component :name="mechCategoryObject?.displayName || 'Mechanical'"
        :is-full-width="isFullWidth"
        :is-quote-hour="isQuoteTypeHour"
        :count="mechLength"
        :total-value="mechTotal"
        :hour-value="mechHourTotal" />
      <div class="rows">
        <draggable @change="itemMoved($event, ItemCategoryTypes.MECH)"
          v-model="innerValue.others"
          @over.prevent
          @enter.prevent
          :clone="$event => cloneHandler($event, ItemCategoryTypes.MECH)"
          :group="{ name: ItemCategoryTypes.MECH, pull: 'clone', put: true }"
          v-bind="{'disabled': !isRowDraggable, chosen: 'chosen', ghostClass: 'draggable-ghost', dragClass: 'draggable-drag'}"
          handle=".item-drag-handle">
          <quote-builder-other-labour-item v-for="item in mechItems"
            :key="item.id"
            :read-only-view="readOnlyView"
            :vehicle="vehicle"
            :inner-value="innerValue"
            :items-assessments="itemsAssessments"
            :is-quote-type-hour="isQuoteTypeHour"
            :is-full-width="isFullWidth"
            :item="item"
            :edit-item-id="editItemObj.id"
            :is-editable="!readOnlyComputed"
            @deleteItem="item => deleteItem(item)"
            @updateValue="updateValue"
            @focusNextRow="id => $emit('focusNextRow', item)"
            @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
            @itemRowClicked="(value, event, close) => $emit('handleItemRowClick',value, event, close)" />
        </draggable>
      </div>
      <div>
        <button class="button is-outlined is-primary"
          @click="addBlankItem($event, ItemCategoryTypes.MECH)"
          :disabled="readOnlyComputed">
          + Add Item
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import QuoteBuilderOtherLabourHeadingsComponent from './QuoteBuilderOtherLabourHeadingsComponent.vue'
import QuoteBuilderOtherLabourItem from './QuoteBuilderOtherLabourItem.vue'
import { ItemCategoryTypes, LabourTimeTypes, PaintGroupTypes, QuotingMethodTypes, QuoteItemRevTypes, EventHubTypes } from '@/enums'
import draggable from 'vuedraggable'
import { QuoteItemModel } from '@/classes/viewmodels'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import { QuoteTotalsMethodMixin, QuoteAssessmentMixin, QuoteItemValidationMixin, QuoteOtherLabourMixin, QuoteItemAutoSaveDeleteMixin } from '../../mixins'
import { cloneDeep } from 'lodash'

export default {
  name: 'QuoteBuilderOtherLabourComponent',
  components: {
    QuoteBuilderOtherLabourHeadingsComponent,
    QuoteBuilderOtherLabourItem,
    draggable
  },
  mixins: [QuoteTotalsMethodMixin, QuoteAssessmentMixin, QuoteItemValidationMixin, QuoteOtherLabourMixin, QuoteItemAutoSaveDeleteMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    isFullWidth: {
      type: Boolean,
      required: true
    },
    editItemObj: {
      type: Object
    },
    selectedTab: {
      type: Object
    },
    selectedViewType: {
      type: String
    },
    viewTypes: {
      type: Object
    },
    vehicle: {
      type: Object
    },
    readOnlyView: {
      type: Boolean
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    isAudanet: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerValue: null,
      isSyncingParentUpdate: false,
      lastEmittedOthersSignature: null
    }
  },
  computed: {
    ItemCategoryTypes() {
      return ItemCategoryTypes
    },
    LabourTimeTypes() {
      return LabourTimeTypes
    },
    PaintGroupTypes() {
      return PaintGroupTypes
    },
    isRowDraggable() {
      return !this.innerValue.readOnly
    },
    QuotingMethodTypes() {
      return QuotingMethodTypes
    },
    isQuoteTypeHour() {
      return this.innerValue.quotingMethod === QuotingMethodTypes.Hour
    },
    mechItems() {
      return this.innerValue.others.filter((i) => i.itemType === ItemCategoryTypes.MECH)
    },
    mechLength() {
      return this.innerValue.others.filter((i) => !(i.deleted || i.isDeleted) && i.itemType == ItemCategoryTypes.MECH)?.length
    },    mechTotal() {
      return this.calculateItemCategoryTotal(this.innerValue.quotingMethod, this.innerValue.others, ItemCategoryTypes.MECH)
    },
    mechHourTotal() {
      return this.calculateItemCategoryHourTotal(this.innerValue.others, ItemCategoryTypes.MECH)
    },
    isNtar() {
      return (
        this.innerValue.labourType === LabourTimeTypes.NTAR ||
        this.innerValue.labourType === LabourTimeTypes.LTAR ||
        this.innerValue.labourType === LabourTimeTypes.eMTA
      )
    },
    itemsAssessments() {
      return this.getItemsAssessments(this.innerValue.others, this.innerValue.quoteAssessments)
    },
    mechCategoryObject() {
      return this.$company.itemCategories.find((i) => i.itemCategoryType === ItemCategoryTypes.MECH)
    },
    readOnlyComputed() {
      return this.innerValue.readOnly || !this.isEditable
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (!newVal) return
        const currentSignature = this.computeOthersSignature(newVal.others)
        if (this.isSyncingParentUpdate && currentSignature === this.lastEmittedOthersSignature) {
          this.isSyncingParentUpdate = false
          return
        }
        // Fast-path: skip deepDiff(entire_entity) when only sibling-derived totals changed
        const innerOthersSignature = this.computeOthersSignature(this.innerValue?.others)
        if (currentSignature === innerOthersSignature &&
            this.innerValue?.quotingMethod === newVal.quotingMethod &&
            this.innerValue?.readOnly === newVal.readOnly) {
          return
        }
        this.innerValue = cloneDeep(newVal)
      },
      deep: true
    },
    innerValue: {
      handler(newVal) {
        if (!newVal || this.isSyncingParentUpdate) return
        const nextSignature = this.computeOthersSignature(newVal.others)
        if (nextSignature === this.lastEmittedOthersSignature) return
        this.lastEmittedOthersSignature = nextSignature
        this.isSyncingParentUpdate = true
        // Merge with latest parent value to avoid emitting stale sibling arrays (Parts, Misc, etc.) when only labours changed.
        const toEmit = { ...this.value, others: cloneDeep(newVal.others) }
        this.$emit('handleUpdate', toEmit)
      },
      deep: true
    }
  },
  created() {
    this.innerValue = cloneDeep(this.value)
    this.lastEmittedOthersSignature = this.computeOthersSignature(this.value?.others)
    // Value is committed to vm.entity after the field's model-update delay.
    // The item watcher in QuoteView triggers autosave once the value propagates.
    this.$watch('innerValue', function () {
    }, { deep: true })
  },
  mounted() {
    this.$v.entity.others.$touch()
    this.$eventHub.$on('updateOthers', this.updateOthers)
    this.$eventHub.$on('addBlankItemOtherLabour', this.addBlankItem)
    this.$eventHub.$on('deleteOtherLabour', this.deleteItem)
  },
  beforeDestroy() {
    this.$eventHub.$off('updateOthers', this.updateOthers)
    this.$eventHub.$off('addBlankItemOtherLabour', this.addBlankItem)
    this.$eventHub.$off('deleteOtherLabour', this.deleteItem)
  },
  methods: {
    computeOthersSignature(items = []) {
      try {
        return JSON.stringify(items)
      } catch (e) {
        return null
      }
    },
    updateOthers() {
      const newItems = this.innerValue.others.filter((i) => i.isNew)

      this.innerValue = cloneDeep(this.value)

      // if there are new items, add them to the innerValue
      if (newItems.length) {
        newItems.forEach((item) => {
          // check if the item already exists in the innerValue
          const existingItem = this.innerValue.others.find((i) => i.itemDesc === item.itemDesc && i.itemNo === item.itemNo)
          if (!existingItem && item.quoteItemId == this.editItemObj.id) {
        // if it doesn't exist, add it
        this.innerValue.others.push(item)
          }
        })
      }

      // compare two objects to see if they are the same, sometimes the parent
      // value might be updated by innervalue and we don't want to update the inner value again
      // const diff = deepDiff(this.innerValue, this.value)
      // if (diff) {
      //   // check changes between parent and child
      //   const hasOthersDiff = diff.some((d) => d.path && d.path[0] === 'others')
      //   const newInnerValue = cloneDeep(this.value)
      //   // if the parent and child are different, merge the changes
      //   if (hasOthersDiff) {
      //     // items that exist in child but not in parent (could be added when tabbing, enter or arrow down)
      //     const newOtherItems = this.innerValue.others.filter((i) => i.isNew)
      //     // if these items don't exist in the new value, add them
      //     newOtherItems.forEach((item) => {
      //       if (!newInnerValue.others.find((i) => i.itemDesc === item.itemDesc && i.itemNo === item.itemNo)) {
      //         newInnerValue.others.push(item)
      //       }
      //     })
      //   }
      //   this.innerValue = newInnerValue
      // }
    },
    cloneHandler(item, type) {
      return item
    },
    itemMoved(event, type) {
      // if an item was dragged from one list to another, i.e from RR to RWA, Parts to RR etc.
      if (event?.added) {
        const item = event.added.element
        this.handleItemAdded(item, type, event.added.newIndex)
      }
      let sortNo = this.innerValue.others.length ? Math.min(...this.innerValue.others.map((i) => i.sortNo || 1)) : 1
      this.innerValue.others.forEach((item) => {
        item.sortNo = sortNo
        sortNo++
      })
      // Emit directly — don't rely on the deep watcher to detect in-place sortNo mutations
      const nextSignature = this.computeOthersSignature(this.innerValue.others)
      this.lastEmittedOthersSignature = nextSignature
      this.isSyncingParentUpdate = true
      this.$emit('handleUpdate', { ...this.value, others: cloneDeep(this.innerValue.others) })
      this.$nextTick(() => { this.isSyncingParentUpdate = false })
    },
    handleItemAdded(item, type, index) {
      const newItem = this.generateItem(item.itemNo, item.itemDesc, item.hourValue, item.rate, type)
      // replace the item with the new item
      newItem.lineNumber = !this.isAudanet ? this.nextLineNumber : 0
      this.innerValue.others.splice(index, 1, newItem)
      this.$emit('onItemCopied', newItem)
    },
    addBlankItem(event) {
      // this is to prevent outside click event from firing, which collpases all the items
      event?.stopPropagation()

      const type = ItemCategoryTypes.MECH

      let hour = 0
      let rate = this.isNtar
        ? this.innerValue.shopRate
        : this.getLabourRate(ItemCategoryTypes.MECH, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate

      const newItem = this.generateItem('', '', hour, rate, type)
      newItem.lineNumber = !this.isAudanet ? this.nextLineNumber : 0
      this.innerValue.others.splice(this.innerValue.others.length, 1, newItem)
      this.innerValue.lines = this.nextLineNumber + 1
      this.$notification.success('', 'Item added')

      // this.$toast.open({
      //   message: 'Item added',
      //   type: 'is-success',
      //   position: 'is-bottom',
      //   queue: false
      // })

      this.$nextTick(() => {
        this.$emit('newItemAdded', newItem.quoteItemId)
      })
    },

    generateItem(itemNo, description, hourValue, rate, type) {
      let newItem = new QuoteItemModel(this.innerValue.quoteId, itemNo, description, type)
      newItem.lineNumber = this.nextLineNumber
      newItem.itemNo = itemNo ? itemNo : this.$filters.pad(newItem.lineNumber, 4)
      newItem.hourValue = this.innerValue.quotingMethod === QuotingMethodTypes.Hour ? hourValue : roundAwayFromZero(hourValue * rate)
      newItem.rate = rate
      newItem.dollarValue = roundAwayFromZero(hourValue * rate)
      newItem.opgCode = this.vehicle.paintGroup
      newItem.sortNo = this.innerValue.others.length ? Math.max(...this.innerValue.others.map((i) => i.sortNo)) + 1 : 1
      return newItem
    },
    updateValue(item) {
      if (this.innerValue.quotingMethod === QuotingMethodTypes.Dollar) {
        item.dollarValue = item.hourValue
      } else {
        item.dollarValue = roundAwayFromZero(item.hourValue * item.rate)
        if (this.getLabourRate(ItemCategoryTypes.MECH, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate === item.rate) {
          item.rev = QuoteItemRevTypes.Normal
        } else {
          item.rev = QuoteItemRevTypes.SpecRate
        }
      }
      // this.updateTotal()
    },

    calculateItemCategoryTotal(quotingMethod, items, itemType) {
      let total = 0

      if (itemType === ItemCategoryTypes.PART) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return roundAwayFromZero(total + item.itemQuantity * item.markupValue)
          }, 0)
      } else if (itemType === ItemCategoryTypes.MISC) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return total + item.value
          }, 0)
      } else if (itemType === ItemCategoryTypes.OPG) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return total + (quotingMethod === QuotingMethodTypes.Dollar ? item.dollarValue : item.hourValue * item.rate)
          }, 0)
      } else if (itemType === ItemCategoryTypes.SUBL) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return total + item.value
          }, 0)
      } else {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly && i.itemType === itemType)
          .reduce(function (total, item) {
            return roundAwayFromZero(total + item.dollarValue)
          }, 0)      }
      return total
    },
    calculateItemCategoryHourTotal(items, itemType) {
      return items
        .filter((i) => !i.deleted && !i.reportOnly && i.itemType === itemType)
        .reduce(function (total, item) {
          return roundAwayFromZero(total + item.hourValue)
        }, 0)
    },
    deleteItem(item) {
      if (item.isNew) {
        const itemIndex = this.innerValue.others
          .map(function (obj) {
            return obj.quoteItemId
          })
          .indexOf(item.quoteItemId)
        if (itemIndex >= 0) {
          this.innerValue.others.splice(itemIndex, 1)
          // this.items.splice(itemIndex, 1)
        }
      } else {
        this.autoSaveDeleteExistingItem(item)
      }

      // Sync the deletion into the Add-Item panel so it isn't re-added.
      this.$eventHub.$emit(EventHubTypes.QuoteItemDeletedSync, item)

      // Propagate the deletion to the parent directly (mirrors itemMoved) rather than
      // relying on the innerValue watcher, which drops emits while isSyncingParentUpdate
      // is true — otherwise a later value echo resets innerValue and resurrects the item.
      this.lastEmittedOthersSignature = this.computeOthersSignature(this.innerValue.others)
      this.isSyncingParentUpdate = true
      this.$emit('handleUpdate', { ...this.value, others: cloneDeep(this.innerValue.others) })
      this.$nextTick(() => { this.isSyncingParentUpdate = false })

      this.$emit('onItemDeleted',  item.lineNumber)

      // this.updateTotal()

      // this.$toast.open({
      //   message: `Item <span class="is-italic">${item.itemDesc}</span> deleted`,
      //   type: 'is-danger',
      //   position: 'is-top',
      //   actionText: 'Undo',
      //   onAction: () => {
      //     if (item.isNew) {
      //       this.innerValue.others.splice(this.innerValue.others.length, 1, item)
      //       // this.items.splice(this.items.length, 1, item)
      //     } else {
      //       item.deleted = false
      //       item.isDeleted = false
      //       item.itemStatus = originalItemStatus
      //     }
      //     // this.updateTotal()
      //   }
      // })
    }
  }
}
</script>

<style scoped>
/* Your component's styles go here */
</style>